// @flow
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Card,
  Row,
  Col,
  Icon,
  Upload,
  Tooltip,
} from 'antd';
import {
  SpText,
  SpButton,
  Line,
  SpStatusTag,
  SpFormWrapper,
  SpWrapper,
  SpH5,
} from 'components/DesignKit';
import { VENDORINVOICEDETAILS } from 'store/actionTypes';
import formatNumber from 'utils/formatNumber';
import getTaxAmount from 'utils/getTaxAmount';
import getDiscountOff from 'utils/getDiscountOff';
import { useLocation } from 'react-router-dom';
import moment from 'moment-timezone';
import {
  INVOICE_TYPES,
  RATE_TYPES,
  COUNTRIES,
} from 'appconstants';
import {
  notificationActions,
  vendorInvoiceDetailsActions,
} from 'store/actions';
import formatAmount from 'utils/formatAmount';
import getInvoiceBackground from 'utils/getInvoiceBackground';
import getInvoiceStatus from 'utils/getInvoiceStatus';
import Download from 'components/NavIcons/downloadIcon';
import swirepaylogo from 'components/NavIcons/swirepay';
import ViewPdfIcon from 'components/NavIcons/viewPdfIcon';
import { informationIcon } from 'components/NavIcons';
import CancelInvoice from './CancelInvoice';
// import AddFundingSource from './components/AddFundingSource';
import ConfirmationPaymentModal from './components/ConfirmationPaymentModal';
import BankLogo from './components/BankLogo';

type Props = {
  invoiceDetails: Object,
  selectedAccount: Object,
  history: {
    push: Function,
  },
  sendInvoice: Function,
  cancelInvoice: Function,
  submitting: boolean,
  validator: boolean,
  invoicePay: Function,
  invoiceDownload: Function,
  isOpenPayModal: Boolean,
  openPayVendorInvoiceModal: Function,

};

const ViewInvoice = (props: Props) => {
  const {
    invoiceDetails,
    selectedAccount,
    sendInvoice,
    cancelInvoice,
    submitting,
    validator,
    invoicePay,
    invoiceDownload,
    isOpenPayModal,
    openPayVendorInvoiceModal,
  } = props;

  const [cancelInvoiceModal, setCancelInvoiceModal] = useState(false);
  const [fundingSourceName, setFundingSourceName] = useState();
  const invoiceLineItems = invoiceDetails.invoiceLineItems ? invoiceDetails.invoiceLineItems : [];
  const totalAmount = invoiceDetails && (invoiceDetails.amount / 100);
  const currencyType = selectedAccount && selectedAccount.currency;
  const allSelectedTaxrates = invoiceDetails.taxAmount ? invoiceDetails.taxAmount : [];
  const currencyPrefix = selectedAccount && selectedAccount.currency && selectedAccount.currency.prefix;
  const currencyObj = selectedAccount && selectedAccount.currency;
  const updatedCoupon = invoiceDetails.coupon ? invoiceDetails.coupon : {};
  const [addFundingSourceModal, setAddFundingSourceModal] = useState(false);
  const issuerName = (selectedAccount.issuer && selectedAccount.issuer.name);
  // eslint-disable-next-line no-unused-vars
  const location = useLocation();
  const isIndia = (selectedAccount && selectedAccount.country && selectedAccount.country.id) === COUNTRIES.INDIA.id;
  const exchangeFee = invoiceDetails?.feeAmount
    ? formatAmount(typeof invoiceDetails?.feeAmount === 'number' && invoiceDetails.feeAmount / 100, currencyType) : 0;
  const tax = invoiceDetails?.feeTax ? formatAmount(typeof invoiceDetails?.feeTax === 'number' && invoiceDetails.feeTax / 100, currencyType) : 0;
  // eslint-disable-next-line max-len
  const lowVolumeFee = invoiceDetails?.lowVolumeFee ? formatAmount(typeof invoiceDetails?.lowVolumeFee === 'number' && invoiceDetails.lowVolumeFee / 100, currencyType) : 0;
  // eslint-disable-next-line max-len
  const convertedAmount = invoiceDetails?.convertedAmount ? formatAmount(typeof invoiceDetails?.convertedAmount === 'number' && invoiceDetails.convertedAmount / 100, currencyType) : 0;
  const exchangeRate = invoiceDetails?.exchangeRate ? typeof invoiceDetails?.exchangeRate === 'number' && invoiceDetails.exchangeRate : 0;
  // eslint-disable-next-line no-unused-vars, max-len
  const totalFee = formatAmount((((typeof invoiceDetails?.feeAmount === 'number' && invoiceDetails?.feeAmount) || 0) + ((typeof invoiceDetails?.lowVolumeFee === 'number' && invoiceDetails?.lowVolumeFee) || 0) + ((typeof invoiceDetails?.feeTax === 'number' && invoiceDetails?.feeTax) || 0)) / 100, currencyType);
  const [crossBorder, setCrossBorder] = useState(false);

  useEffect(() => {
    if (!validator) {
      setCancelInvoiceModal(false);
      setAddFundingSourceModal(false);
      openPayVendorInvoiceModal({
        type: VENDORINVOICEDETAILS.OPEN_PAY_MODAL,
        payload: false,
      });
    }
  }, [validator]);


  useEffect(() => {
    if (invoiceDetails && invoiceDetails?.fundingSource?.issuerBank) {
      const { issuerBank, contact } = invoiceDetails?.fundingSource;
      if (issuerBank) {
        let fundName = '';
        if (contact?.name && issuerBank.bankName && issuerBank.lastFour) {
          fundName = `${contact?.name} | ${issuerBank.bankName} ****${issuerBank.lastFour}`;
        } else if (issuerBank.vpa) {
          fundName = issuerBank.vpa;
        } else if (issuerBank.bankName) {
          fundName = issuerBank.bankName;
        } else if (issuerBank.lastFour) {
          fundName = `****${issuerBank.lastFour}`;
        }
        setCrossBorder(issuerBank?.country?.alpha2 === 'IN');
        setFundingSourceName(fundName);
      }
    }
  }, [invoiceDetails]);

  useEffect(() => {
    if (isOpenPayModal) {
      setAddFundingSourceModal(true);
    }
  }, [isOpenPayModal]);

  const updateInvoice = () => {
    sendInvoice();
  };

  const deleteInvoice = () => {
    cancelInvoice();
  };

  const downloadPdf = () => {
    invoiceDownload();
  };

  const PayInvoice = (payload) => {
    invoicePay(payload);
  };

  const getAmountOff = (value) => {
    let amountOff;
    if (value.percentageOff) {
      const amount = (totalAmount * value.percentageOff) / 100;
      amountOff = formatNumber((amount).toFixed(2), currencyObj);
    } else if (value.amountOff) {
      amountOff = formatNumber((value.amountOff / 100).toFixed(2), currencyObj);
    }
    return amountOff;
  };

  const getTotalAmount = (value) => {
    let finalAmount;
    if (value) {
      const finalValue = parseFloat(value.replace(/,/g, ''));
      finalAmount = formatNumber((totalAmount - finalValue).toFixed(2), currencyObj);
    } else {
      finalAmount = formatNumber((totalAmount).toFixed(2), currencyObj);
    }
    return finalAmount;
  };

  const getFinalTotalAmount = (value) => {
    const finalAmount = formatNumber((value / 100).toFixed(2), currencyObj);
    return finalAmount;
  };

  const getFinalAmount = (amount) => {
    let finalAmount;
    const listOfTaxes = [...allSelectedTaxrates];
    const taxLists = listOfTaxes.filter((item) => item.taxRates.inclusive === false);
    if (taxLists.length > 0) {
      const percentageAmount = taxLists.reduce(
        (total, item) => total + ((parseFloat(amount.replace(/,/g, '')) * item.taxRates.percentage) / 100), 0,
      );
      finalAmount = formatNumber((parseFloat(amount.replace(/,/g, '')) + percentageAmount).toFixed(2), currencyObj);
    } else {
      finalAmount = amount;
    }
    return finalAmount;
  };

  const handleViewPdf = () => {
    window.open(invoiceDetails.invoiceDocument, '_blank');
  };
  const invoiceStatus = getInvoiceStatus(invoiceDetails.status);
  const displayStatus = invoiceStatus === 'Payment Due' ? 'Active' : invoiceStatus;
  return (
    <Card>
      <Row type="flex" justify="space-between" className="my-2 mb-3 mt-2">
        <Col className="d-flex align-items-center">
          <SpText className="mr-5" fontSize="20px" fontWeight="600">INVOICE # {invoiceDetails.invoiceNumber}</SpText>
          <SpStatusTag
            style={{ backgroundColor: displayStatus === 'Active' ? '#C9FFEF' : getInvoiceBackground(invoiceDetails.status), height: '21px' }}
          >
            {displayStatus}
          </SpStatusTag>
        </Col>
        <Col style={{ marginRight: '21px' }}>
          <span
            style={{
              cursor: 'pointer',
            }}
            onClick={downloadPdf}
          >
            <Icon
              component={Download}
              onClick={downloadPdf}
            /> <SpText color="#279dfe" fontWeight="600">Download</SpText>
          </span>
          {
            invoiceDetails.status === INVOICE_TYPES.ACTIVE && (
              <>
                <SpButton
                  type="secondary"
                  shape="round"
                  className="ml-4 mr-4"
                  ghost
                  onClick={() => setCancelInvoiceModal(true)}
                >
                  Cancel Invoice
                </SpButton>
                <SpButton
                  type="primary"
                  shape="round"
                  className="mr-4"
                  onClick={() => setAddFundingSourceModal(true)}
                >
                  Pay
                </SpButton>
              </>
            )
          }
          {
            invoiceDetails.status === INVOICE_TYPES.PAST_DUE && (
              <>
                <SpButton
                  type="secondary"
                  shape="round"
                  className="mr-4"
                  ghost
                  onClick={() => setCancelInvoiceModal(true)}
                >
                  Cancel Invoice
                </SpButton>
                <SpButton
                  type="primary"
                  shape="round"
                  className="mr-4"
                  onClick={updateInvoice}
                >
                  Resend Invoice
                </SpButton>
              </>
            )
          }
        </Col>
      </Row>
      {/* CANCEL INVOICE MODAL */}
      {cancelInvoiceModal && (
        <CancelInvoice
          visible={cancelInvoiceModal}
          invoiceNo={invoiceDetails.invoiceNumber}
          submitting={submitting}
          close={() => setCancelInvoiceModal(false)}
          submit={deleteInvoice}
        />
      )}
      {/* ADD FUNDING SOURCE MODAL */}
      {/* {addFundingSourceModal && (
        <AddFundingSource
          visible={addFundingSourceModal}
          submitting={submitting}
          selectedAccount={selectedAccount}
          country={selectedAccount.country.name}
          cntryId={selectedAccount.country.id}
          isIndia={isIndia}
          issuerName={issuerName}
          invoiceDetails={invoiceDetails}
          contactGid={invoiceDetails && invoiceDetails.contact && invoiceDetails.contact.gid}
          close={() => setAddFundingSourceModal(false)}
          submit={PayInvoice}
        />
      )} */}
      {/* ADD FUNDING SOURCE MODAL */}
      {addFundingSourceModal && (
        <ConfirmationPaymentModal
          visible={addFundingSourceModal}
          submitting={submitting}
          selectedAccount={selectedAccount}
          country={selectedAccount.country.name}
          cntryId={selectedAccount.country.id}
          isIndia={isIndia}
          issuerName={issuerName}
          invoiceDetails={invoiceDetails}
          invoiceFundingSourceName={fundingSourceName}
          contactGid={invoiceDetails && invoiceDetails.contact && invoiceDetails.contact.gid}
          isCrossBorder={crossBorder}
          close={() => setAddFundingSourceModal(false)}
          submit={PayInvoice}
        />
      )}
      <SpWrapper>
        <SpFormWrapper>
          <Row type="flex" justify="space-between" className="my-2 mb-3 mt-2">
            <Col className="d-flex align-items-center">
              {
                selectedAccount && selectedAccount.largeLogo ? (
                  <img src={selectedAccount.largeLogo} alt={selectedAccount.name} style={{ width: '108px', height: '74px' }} />
                ) : (
                  <SpText className="mr-5" fontSize="20px" fontWeight="600">{selectedAccount.name}</SpText>
                )
              }
            </Col>
            <Col className="d-flex">
              <div className="mr-2 mt-3">
                <SpText color="rgba(0, 0, 0, 0.7)">Powered by</SpText>
              </div>
              <Icon
                style={{
                  fontSize: '24px',
                }}
                component={swirepaylogo}
              />
            </Col>
          </Row>
          <Row type="flex" className="my-2 mb-3 mt-2">
            <Col className="d-flex align-items-center" span={12}>
              <SpText className="mr-2" fontSize="18px">INVOICE No.</SpText>
              <SpText fontSize="18px" fontWeight="600">{invoiceDetails.invoiceNumber}</SpText>
            </Col>
          </Row>
          <Row type="flex" className="my-2 mb-3 mt-2">
            <Col span={12}>
              <div className="pt-1 pb-1"><SpText fontWeight="600">Service Date</SpText></div>
              <div className="pt-1 pb-1">
                <SpText color="#434343">
                  {
                    invoiceDetails.issueDate && selectedAccount
                      ? (
                        moment
                          .utc(invoiceDetails.issueDate)
                          .tz(selectedAccount.timezone)
                          .format('MMM DD, YYYY')
                      )
                      : <>&#8211;</>
                  }
                </SpText>
              </div>
            </Col>
            <Col span={12}>
              <div className="pt-1 pb-1"><SpText fontWeight="600">Contact</SpText></div>
              <div className="pt-1 pb-1">
                <SpText color="#434343">
                  {invoiceDetails?.contact?.name}{' '}
                  {invoiceDetails?.fundingSource?.issuerBank?.bankName && invoiceDetails?.fundingSource?.issuerBank?.lastFour
                    ? (
                      <>
                        | <BankLogo bankName={invoiceDetails?.fundingSource?.issuerBank?.bankName} />
                        **** {invoiceDetails?.fundingSource?.issuerBank?.lastFour}
                      </>
                    )
                    : null}
                </SpText>
              </div>
            </Col>
          </Row>
          <Row type="flex" className="my-2 mb-3 mt-2">
            <Col span={12}>
              <div className="pt-1 pb-1"><SpText fontWeight="600">Transfer Date</SpText></div>
              <div className="pt-1 pb-1">
                <SpText color="#434343">
                  {
                    invoiceDetails.transferDueDate && selectedAccount
                      ? (
                        moment(invoiceDetails.transferDueDate).format('MMM DD, YYYY')
                      )
                      : <>&#8211;</>
                  }
                </SpText>
              </div>
            </Col>
            <Col span={12}>
              <div className="pt-1 pb-1"><SpText fontWeight="600">Transfer Type</SpText></div>
              <div className="pt-1 pb-1"><SpText color="#434343">{invoiceDetails?.transferType?.value.replace(/_/g, ' ') ?? '-'}</SpText></div>
            </Col>
          </Row>
          <Row type="flex" className="my-2 mb-3 mt-2">
            <Col span={24}>
              <div className="pt-1 pb-1"><SpText fontWeight="600">Description</SpText></div>
              <div className="pt-1 pb-1 pr-5"><SpText color="#434343">{invoiceDetails.description}</SpText></div>
            </Col>
          </Row>
          <Row type="flex" className="my-2 mb-3 mt-2">
            <Col span={12}>
              <div className="pt-1 pb-1"><SpText fontWeight="600">Billing Address</SpText></div>
              <div className="pt-1 pb-1 pr-5">
                {
                  invoiceDetails.billingAddress && invoiceDetails.billingAddress.street ? (
                    <SpText color="#434343">
                      {`${invoiceDetails.billingAddress.street}, ${invoiceDetails.billingAddress.city}, 
                      ${invoiceDetails.billingAddress.state} ${invoiceDetails.billingAddress.postalCode}`}
                    </SpText>
                  ) : (
                    <SpText color="#434343">
                      N/A
                    </SpText>
                  )
                }
              </div>
            </Col>
            <Col span={12}>
              <div className="pt-1 pb-1"><SpText fontWeight="600">Shipping Address</SpText></div>
              <div className="pt-1 pb-1 pr-5">
                {
                  invoiceDetails.shippingAddress && invoiceDetails.shippingAddress.street ? (
                    <SpText color="#434343">
                      {`${invoiceDetails.shippingAddress.street}, ${invoiceDetails.shippingAddress.city}, 
                      ${invoiceDetails.shippingAddress.state} ${invoiceDetails.shippingAddress.postalCode}`}
                    </SpText>
                  ) : (
                    <SpText color="#434343">
                      N/A
                    </SpText>
                  )
                }
              </div>
            </Col>
          </Row>
          <Row type="flex" className="my-2 mb-3 mt-2" style={{ background: '#eeeeff', padding: '5px' }}>
            <Col span={12}>
              <div className="pt-1 pb-1 pl-2"><SpText fontWeight="600">Description</SpText></div>
            </Col>
            <Col span={12}>
              <Row type="flex" justify="end">
                <Col span={6} className="pt-1 mr-3" align="center">
                  <SpText fontWeight="600" fontSize="14px">Rate</SpText>
                </Col>
                <Col span={6} className="pt-1 mr-3" align="center">
                  <SpText fontWeight="600" fontSize="14px">Quantity</SpText>
                </Col>
                <Col span={6} className="pt-1 mr-3" align="right">
                  <SpText fontWeight="600" fontSize="14px">Total</SpText>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row type="flex" className="my-2 mb-3 mt-2" style={{ padding: '0 5px' }}>
            {invoiceLineItems.map((item) => (
              <>
                <Col span={12}>
                  <div className="pt-1 pb-1 pl-2"><SpText>{item.name}</SpText></div>
                </Col>
                <Col span={12}>
                  <Row type="flex" justify="end">
                    <Col span={6} className="mr-3" align="center">
                      <SpText fontWeight="600">{invoiceDetails.currency.prefix} {(item.amount / 100).toFixed(2)}</SpText>
                    </Col>
                    <Col span={6} className="mr-3" align="center">
                      <SpText fontWeight="600">{item.quantity}</SpText>
                    </Col>
                    <Col span={6} className="mr-3" align="right">
                      <SpText fontWeight="600">{invoiceDetails.currency.prefix}
                        {formatNumber(((item.amount / 100) * (item.quantity)).toFixed(2), currencyType)}
                      </SpText>
                    </Col>
                  </Row>
                </Col>
              </>
            ))}
          </Row>
          <Row type="flex" justify="end" className="ml-5 mb-2">
            {updatedCoupon.gid && (
              <Col span={14}>
                <Row type="flex" justify="end">
                  <Col span={12} className="pt-1 ml-3" align="left">
                    <div className="pt-1 pb-1" style={{ cursor: 'pointer' }}>
                      <SpText>
                        {updatedCoupon.name}
                      </SpText><br />
                      <SpText fontSize="12px">
                        {getDiscountOff(updatedCoupon)}
                      </SpText>
                    </div>
                  </Col>
                  <Col span={6} className="pt-2 ml-5 mr-3" align="right">
                    <SpText fontWeight="600">({currencyPrefix} {getAmountOff(updatedCoupon)})</SpText>
                  </Col>
                  <Col span={2} className="pt-1" align="right" />
                </Row>
              </Col>
            )}
          </Row>
          <Row type="flex" justify="end" className="ml-5">
            {
              allSelectedTaxrates.map((item) => (
                <Col span={14}>
                  <Row type="flex" justify="end">
                    <Col span={9} className="pt-1 ml-3" align="left">
                      <div className="pt-1 pb-1" style={{ cursor: 'pointer' }}>
                        <SpText>
                          {item.taxRates.displayName}
                        </SpText><br />
                        <SpText fontSize="12px">
                          {item.taxRates.inclusive ? RATE_TYPES.INCLUSIVE : RATE_TYPES.EXCLUSIVE}
                        </SpText>
                      </div>
                    </Col>
                    <Col span={3} className="pt-1" align="right">{item.taxRates.percentage} %</Col>
                    <Col span={6} className="pt-2 ml-5 mr-3" align="right">
                      <SpText fontWeight="600">
                        {currencyPrefix} {getTaxAmount(item.taxRates, totalAmount, getAmountOff(updatedCoupon), selectedAccount)}
                      </SpText>
                    </Col>
                    <Col span={2} className="pt-1" align="right" />
                  </Row>
                </Col>
              ))
            }
          </Row>
          <Line opacity="0.3" className="mt-1 mb-1" />
          <Row type="flex" justify="end" className="mr-3">
            <Col className="mt-1 pb-1">
              {Number(convertedAmount) !== 0 ? (
                <>
                  <SpText className="mr-2" fontWeight="400" fontSize="14px">
                    (Converted Amount
                  </SpText>
                  <SpText fontWeight="400" fontSize="14px" className="mr-3">
                    {(convertedAmount) ? `₹  ${(convertedAmount)}` : <>&#8211;</>})
                  </SpText>
                </>
              ) : (<></>)}
              <SpText className="mr-5" fontWeight="500" fontSize="20px">
                {Number(totalFee) !== 0 ? 'Amount' : 'Total Amount'}
              </SpText>
              <SpText fontWeight="600" fontSize="20px">
                {
                  (getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon)))) < 0 ? (
                    `${currencyPrefix} 0.00`
                  ) : (
                    `${currencyPrefix} ${getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon)))}`
                  )
                }
              </SpText>
            </Col>
          </Row>
          {Number(totalFee) !== 0 ? (
            <>
              <Row type="flex" justify="end" className="mr-3">
                <Col className="mt-1 pb-1">
                  <SpText className="mr-5" fontWeight="400" fontSize="18px">
                    Total fees
                    <Tooltip
                      placement="right"
                      title={(
                        <div style={{ textAlign: 'right' }}>
                          {(exchangeFee || tax) ? (
                            <>
                              <SpText color="#ffffff" className="mr-2" fontWeight="400" fontSize="12px">
                                Bank account (ACH) fee
                              </SpText>
                              <SpText color="#ffffff" fontWeight="400" fontSize="12px">
                                {(exchangeFee || tax) ? `${currencyPrefix} ${(exchangeFee + tax)}` : <>&#8211;</>}
                              </SpText>
                            </>
                          ) : (<></>)}
                          {(exchangeFee || tax) && lowVolumeFee ? (
                            <br />
                          ) : (<></>)}
                          {(lowVolumeFee) ? (
                            <>
                              <SpText
                                className="mr-3"
                                fontWeight="400"
                                fontSize="12px"
                                color="#ffffff"
                              >
                                Low volume fee
                              </SpText>
                              <SpText color="#ffffff" fontWeight="400" fontSize="12px">
                                {`${currencyPrefix} ${lowVolumeFee}`}
                              </SpText>
                            </>
                          ) : (<></>)}
                        </div>
                        )}
                    >
                      <Icon
                        style={{
                          fontSize: '12px',
                          marginLeft: '3px',
                          marginBottom: '3px',
                          cursor: 'pointer',
                        }}
                        component={informationIcon}
                      />
                    </Tooltip>
                  </SpText>
                  <SpText fontWeight="400" fontSize="18px">
                    {currencyPrefix} {totalFee}
                  </SpText>
                </Col>
              </Row>
              <Line opacity="0.3" className="mt-1 mb-1" />
              <Row type="flex" justify="end" className="mr-3">
                <Col className="mt-1 pb-1">
                  <SpText className="mr-5" fontWeight="500" fontSize="20px">
                    Total Amount
                  </SpText>
                  <SpText fontWeight="600" fontSize="20px">
                    {
                      (
                          `${currencyPrefix} ${getFinalTotalAmount(invoiceDetails?.total || 0)}`
                      )
                    }
                  </SpText>
                </Col>
              </Row>
            </>
          ) : (<></>)}
          <Line />
          {
            invoiceDetails?.invoiceDocument ? (
              <div style={{ border: '2px solid #EBEBEB' }} className="mt-2">

                <Row className="my-2 mb-3 mt-4">
                  <Col>
                    <Upload
                      name="avatar"
                      className="avatar-uploader ml-3"
                      showUploadList={false}
                      disabled
                    >
                      <ViewPdfIcon />
                    </Upload>
                    <span
                      className="ml-4 cursor-pointer"
                      onClick={handleViewPdf}
                    >
                      <SpText color="#279dfe" fontWeight="600">View</SpText>
                    </span>
                  </Col>
                </Row>
              </div>
            ) : (
              null
            )
          }
          {
            invoiceDetails.recipientsEmail && invoiceDetails.recipientsEmail.length !== 0 ? (
              <>
                <Row type="flex">
                  <Col span={12}>
                    <div className="pt-1 pb-1">
                      <SpText fontWeight="600">Recipient List</SpText>
                    </div>
                  </Col>
                </Row>
                {(invoiceDetails.recipientsEmail).map((item) => (
                  <Row>
                    <Col span={12}>
                      <div className="pb-1"><SpText>{item}</SpText></div>
                    </Col>
                  </Row>
                ))}
              </>
            ) : null
          }
          <Row className="my-2 mb-3 mt-2">
            <Col>
              <div className="pt-1 pb-1"><SpText fontWeight="600">Notes</SpText></div>
              <div className="pt-1 pb-1">
                <SpText color="#434343">
                  {invoiceDetails.vendorNote}
                </SpText>
              </div>
            </Col>
          </Row>
          <Row className="my-2 mb-3 mt-2" style={{ background: '#eeeeff', padding: '5px' }}>
            <Col>
              <SpText fontWeight="600">{selectedAccount.name}</SpText>
            </Col>
          </Row>
        </SpFormWrapper>
      </SpWrapper>
      <Row type="flex" justify="end" gutter={[16, 16]} className="pt-3">
        <Col>
          <SpH5 color="#7f7f7f">{invoiceDetails.gid}</SpH5>
        </Col>
      </Row>
    </Card>
  );
};
const mapStateToProps = (state) => ({
  isOpenPayModal: state.vendorInvoiceDetails.isOpenPayModal,
});
const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  openPayVendorInvoiceModal: ({ type, payload }) => dispatch(vendorInvoiceDetailsActions.openPayVendorInvoiceModal({
    type,
    payload,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(ViewInvoice);
